import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import { store } from '../store.js'

import iOSLanding from '../components/iOSLanding'
import GetStarted from '../components/GetStarted'
import SignIn from '../components/SignIn'
import EventList from '../components/EventList'
import Event from '../components/Event'
import MessageList from '../components/MessageList'
import Settings from '../components/Settings'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '*',
			redirect: '/events'
		},
		{
			path: '/ioslanding',
			name: 'iOSLanding',
			component: iOSLanding
		},
		{
			path: '/getstarted',
			name: 'GetStarted',
			component: GetStarted
		},
		{
			path: '/signin',
			name: 'SignIn',
			component: SignIn
		},
    {
			path: '/events',
			name: 'EventList',
			component: EventList,
				meta: { requiresAuth: true }
		},
    {
			path: '/event',
			name: 'Event',
			component: Event,
				meta: { requiresAuth: true }
		},
    {
			path: '/messages',
			name: 'MessageList',
			component: MessageList,
				meta: { requiresAuth: true }
		},
    {
			path: '/settings',
			name: 'Settings',
			component: Settings,
				meta: { requiresAuth: true }
		}
	]
})

router.beforeEach((to, from, next) => {
  const platform = require('platform');
	const globals = require('../globals.js');
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const authUser = firebase.auth().currentUser;

	// Only proceed to iOS landing page if the platform is both iOS AND the OS version number is greater than or equal to native iOS minimum
  if (to.path !== '/ioslanding' && platform.os.toString().startsWith('iOS') && parseInt(platform.os.toString().split(' ').pop(), 10) >= globals.minimumNativeVersion_iOS) {
    next('/ioslanding')
  }
	// TODO: When native Android app is available, add a similar if-else as above to check Android OS version and proceed to Android landing
  else if (requiresAuth && (!authUser || !store.getters.appUser)) {
    next('/getstarted')
  }
  else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js